import { data, EntityApi } from '@portal/pkg-api/shared'
import { EntityDetail } from '@portal/pkg-api/gen/navigator'

const prefix = 'shared.entity'

export const EntityQueries = {
  getEntity: (id?: number | null) => ({
    queryKey: [`${prefix}.getEntity`, id],
    queryFn: async (): Promise<EntityDetail | null> => {
      if (!id) {
        return null
      }
      return await data(EntityApi.getEntity(id))
    },
  }),
}
